/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
 */
export interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    selected_option: string;
}

/**
 * Check if a given object implements the InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner interface.
 */
export function instanceOfInstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner(value: object): value is InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('selected_option' in value) || value['selected_option'] === undefined) return false;
    return true;
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'selected_option': json['selected_option'],
    };
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSONTyped(value?: InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'selected_option': value['selected_option'],
    };
}

